import mixpanel from 'mixpanel-browser';

mixpanel.init('04a82da55cd1018c92e2ffd595e33037');


// let env_check = process.env.NODE_ENV === 'production';
let env_check = process.env.NODE_ENV === 'development';

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;